import guest from '@/router/middlewares/guest';
import auth from '@/router/middlewares/auth';
import LoginView from '@/pages/auth/login/index.vue';
import SignUpView from '@/pages/auth/signup/index.vue';
import RegisterView from '@/pages/auth/signup/register.vue';
import ForgotPasswordView from '@/pages/auth/forgotPassword/index.vue';
import InviteLinkView from '@/pages/auth/inviteLink/index.vue';
import VerifyView from '@/pages/auth/signup/verify.vue';

export default [
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
    meta: {
      layout: 'GuestLayout',
      middleware: [guest]
    }
  },
  {
    path: '/reset',
    name: 'ForgotPassword',
    component: ForgotPasswordView,
    meta: {
      layout: 'GuestLayout',
      middleware: [guest]
    }
  },
  {
    path: '/signup',
    name: 'SignUpIndex',
    component: SignUpView,
    meta: {
      layout: 'GuestLayout',
      middleware: [guest]
    },
    children: [
      {
        path: '/signup',
        name: 'Register',
        component: RegisterView
      },
      {
        path: '/verify',
        name: 'Verify',
        component: VerifyView
      }
    ]
  },
  {
    path: '/invite',
    name: 'InviteLink',
    component: InviteLinkView,
    meta: {
      layout: 'GuestLayout',
      middleware: [guest]
    }
  }
];
